import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { format } from '@office-start/string-formatter-utility';
import { logError } from '@office-start/telemetry-service';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
import { licenseStatusUrlFormat } from '../models/constants';
export var getLicenseStatusFromShellService = function (app, scenarioId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, componentContext, identity, url, requestConfig, response, _b, debugInfo;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!app || !scenarioId) {
                    return [2 /*return*/, Promise.resolve(undefined)];
                }
                return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                    ])];
            case 1:
                _a = __read.apply(void 0, [_c.sent(), 2]), componentContext = _a[0], identity = _a[1];
                url = format(licenseStatusUrlFormat, componentContext.officeHomeApiRoot, app, scenarioId);
                requestConfig = {
                    method: "GET" /* HttpRequestMethod.Get */,
                    responseType: "json" /* HttpResponseContentType.Json */,
                    url: url,
                };
                return [4 /*yield*/, applyOfficeIdentity(requestConfig, componentContext.inMockMode, componentContext.workload, function () { return Promise.resolve(identity); })];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3:
                _c.trys.push([3, 5, , 6]);
                return [4 /*yield*/, httpGet(KnownInstrumentationEvents.OfficeLicensesFetch, "Office_Licenses_Fetch" /* KnownRequestInstrumentationEvents.OfficeLicensesFetch */, requestConfig.url, requestConfig, componentContext.jwtAuthEnabled, componentContext.getAccessToken, componentContext.officeHomeApiRoot, componentContext.correlationId, 'OfficeHome', {})];
            case 4:
                response = _c.sent();
                return [3 /*break*/, 6];
            case 5:
                _b = _c.sent();
                return [3 /*break*/, 6];
            case 6:
                if (!response || !response.ok || !response.data) {
                    debugInfo = "Failed to get license status for app: ".concat(app, ", scenarioId: ").concat(scenarioId);
                    logError({
                        eventName: KnownInstrumentationEvents.OfficeLicensesFetch,
                        errorType: 'Office_Licenses_Fetch_Error',
                        message: 'Failed to fetch license status',
                        debugInfo: debugInfo,
                    });
                    return [2 /*return*/, undefined];
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
//# sourceMappingURL=getLicenseStatusFromShellService.js.map